import Agreement from "./Agreement"; //$IMPORT$

export default () => [
  {
    resourceName: "h5",
    routerUrl: "/h5",
    resourceIcon: "",
    type: "0",
    buttons: [],
    children: [
      Agreement(), //$MORE$
    ],
  },
];
